import React from 'react';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, marginBottom } from '../../../helpers/getEmailStyles';

class AdminListDecline extends React.Component {

	render() {
		const { content: { hostName, listId, listTitle, logo, reason, siteName } } = this.props;

		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
				<div style={body}>
					<div style={fontWeightBold}>
						Dear {hostName},
					</div>
					<EmptySpace height={20} />
					<div>
						Unfortunately, your listing has been declined by the admin. Please check the reason for rejection, update the details, and resubmit it for approval.
					</div>
					<EmptySpace height={20} />
					<div style={marginBottom}><span style={fontWeightBold}>Listing Details:-</span></div>
					<div style={marginBottom}><span style={fontWeightBold}>ID:</span> {listId}</div>
					<div style={marginBottom}><span style={fontWeightBold}>Title:</span> {listTitle}</div>
					<div><span style={fontWeightBold}>Reason for Rejection:</span> {reason}</div>
					<EmptySpace height={20} />
					<div>
						Let us know if you need any help.
					</div>
					<EmptySpace height={20} />
					<EmailSignature siteName={siteName} />
				</div>
				<EmptySpace height={40} />
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}

}

export default AdminListDecline;